import { Guid } from '@ef-carbon/primitive';
import { factory as discourseFactory } from './discourse/factory';
import { Meta } from './formation/Meta';
import { factory as linkFactory } from './link/factory';
export class Formation {
    constructor({id, discourse, link, tags, factory, meta}) {
        this.id = new Guid(id);
        this.discourse = discourseFactory(discourse, factory);
        this.link = linkFactory(link);
        this.tags = tags ? Array.from(tags).filter(t => typeof t === 'string') : [];
        this.meta = new Meta(meta || {});
        const descriptors = Object.getOwnPropertyDescriptors(this);
        descriptors.id.configurable = false;
        descriptors.discourse.configurable = false;
        descriptors.link.configurable = false;
        descriptors.tags.configurable = false;
        descriptors.meta.configurable = false;
        Object.defineProperties(this, descriptors);
    }
}
export const klass = Formation;
export default Formation;    //# sourceMappingURL=Formation.js.map
